import React from 'react';
import {Form} from 'formik';
import AbstractModalView from 'common/components/AbstractModalView';
import FieldInput from '../FieldInput';
import share from "../../../modules/InspectedList/assets/share.svg";
import FieldTextareaAutosize from "../FieldTextareaAutosize";
import PropTypes from "prop-types";
import styles from './styles.module.scss';

const ModalSendFinalPDFView = ({
                                 shumaId,
                                 values,
                                 message,
                                 buttonLabel,
                                 recipientType,
                                 recipientTypeLabel,
                                 handleSendFinalPDF,
                                 bankEmail,
                                 fieldErrors
                               }) => {
  const emailAddress = Boolean(values.emailAddress) ? values.emailAddress : bankEmail;

  return (
    <AbstractModalView
      subPath={`send-final-pdf-${shumaId}-${recipientTypeLabel}`}
      modalClassName={styles.modalSendFinalPDFContainer}
      triggerContent={({openModal}) => (
        <div
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            openModal();
          }}
          className={styles.menuItem}
        >
          <img src={share} alt="share" className={styles.icon}/>
          <p className={styles.label}>{buttonLabel}</p>
        </div>
      )}
      modalContent={({closeModal}) => (
        <div className={styles.modalContainer}>
          <h2 className={styles.modalHeader}>{message}</h2>
          <Form>
            <div className={styles.modalContentContainer}>
              {((recipientType === 2 && !bankEmail) || (recipientType === 3)) && (
                <div className={styles.textField}>
                  <FieldInput
                    fieldId={'emailAddress'}
                    type={'email'}
                    value={values.emailAddress}
                    label='כתובת מייל'
                  />
                </div>
              )
              }
              {(recipientType === 3) && (
                <div className={styles.textField}>
                  <FieldTextareaAutosize
                    fieldId={'bodyText'}
                    value={values.bodyText}
                    label='מלל לגוף ההודעה'
                  />
                </div>
              )}
            </div>
          </Form>
          <div className={styles.modalButtons}>
            <button
              type="button"
              className={styles.buttonCancel}
              onClick={() => {
                closeModal();
              }}
            >
              <span>סגירה</span>
            </button>
            <button
              type="submit"
              className={styles.buttonApprove}
              onClick={() => {
                handleSendFinalPDF(
                  shumaId,
                  recipientType,
                  emailAddress,
                  values.bodyText
                );
                closeModal();
              }}
              disabled={Object.keys(fieldErrors).length}
            >
              <span>אישור</span>
            </button>
          </div>
        </div>
      )}
    />
  )
};

ModalSendFinalPDFView.propTypes = {
  shumaId: PropTypes.number,
  message: PropTypes.string,
  buttonLabel: PropTypes.string,
  recipientType: PropTypes.number,
  recipientTypeLabel: PropTypes.string,
  bankEmail: PropTypes.string,
  fieldErrors: PropTypes.object,
};

export default ModalSendFinalPDFView;
